module.exports = __webpack_public_path__ + "img/diy4.6ab8faaf.png";